/**
 * Demo project tạo từ tour Hướng dẫn.
 * Project có flag isDemo=true để badge UI + cleanup riêng.
 */

import { Project, TranslationFile, SynonymGroup } from '../types';

export const DEMO_PROJECT_ID = 'demo-tour-project';
const DEMO_FILE_ID = 'demo-tour-file';

const DEMO_SOURCE_TEXT = `CHƯƠNG 1 — TỔNG QUAN

Công ty TNHH Dịch Tài Liệu là đơn vị tiên phong trong lĩnh vực dịch thuật chuyên ngành tại Việt Nam.

Doanh thu năm 2025 đạt 12 tỷ đồng, tăng trưởng 35% so với năm trước.

Đội ngũ gồm 8 chuyên viên dịch thuật và 3 quản lý dự án có kinh nghiệm trên 5 năm trong các ngành tài chính, pháp lý và xuất nhập khẩu.`;

export const DEMO_TERMS: SynonymGroup[] = [
    {
        id: 'demo-term-1',
        name: 'Doanh thu',
        sources: ['Doanh thu'],
        targets: [{ id: 'dt-1', text: 'Revenue', isDefault: true }],
        category: 'Tài chính',
        order: 1,
    },
    {
        id: 'demo-term-2',
        name: 'Quản lý dự án',
        sources: ['Quản lý dự án', 'QLDA'],
        targets: [{ id: 'qlda-1', text: 'Project Manager', isDefault: true }],
        category: 'Nhân sự',
        order: 2,
    },
    {
        id: 'demo-term-3',
        name: 'Công ty TNHH',
        sources: ['Công ty TNHH'],
        targets: [{ id: 'tnhh-1', text: 'Limited Liability Company', isDefault: true }, { id: 'tnhh-2', text: 'LLC', context: 'viết tắt' }],
        category: 'Pháp lý',
        order: 3,
    },
    {
        id: 'demo-term-4',
        name: 'Xuất nhập khẩu',
        sources: ['Xuất nhập khẩu', 'XNK'],
        targets: [{ id: 'xnk-1', text: 'Import-Export', isDefault: true }],
        category: 'Tài chính',
        order: 4,
    },
    {
        id: 'demo-term-5',
        name: 'Ngân hàng TMCP Xuất Nhập Khẩu Việt Nam',
        sources: ['Ngân hàng TMCP Xuất Nhập Khẩu Việt Nam', 'Eximbank Việt Nam', 'Eximbank'],
        targets: [
            { id: 'exim-1', text: 'Vietnam Export Import Commercial Joint Stock Bank', isDefault: true },
            { id: 'exim-2', text: 'Eximbank', context: 'tên gọi tắt' },
        ],
        category: 'Tổ chức',
        order: 5,
    },
    {
        id: 'demo-term-6',
        name: 'Ngân hàng Nhà nước Việt Nam',
        sources: ['Ngân hàng Nhà nước Việt Nam', 'NHNN', 'NHNN Việt Nam'],
        targets: [
            { id: 'sbv-1', text: 'State Bank of Vietnam', isDefault: true },
            { id: 'sbv-2', text: 'SBV', context: 'viết tắt' },
        ],
        category: 'Tổ chức',
        order: 6,
    },
    {
        id: 'demo-term-7',
        name: 'Hội đồng quản trị',
        sources: ['Hội đồng quản trị', 'HĐQT'],
        targets: [
            { id: 'bod-1', text: 'Board of Directors', isDefault: true },
            { id: 'bod-2', text: 'BoD', context: 'viết tắt' },
        ],
        category: 'Nhân sự',
        order: 7,
    },
];

export function createDemoProject(): Project {
    return {
        id: DEMO_PROJECT_ID,
        name: '📚 Demo - Hướng dẫn',
        type: 'translate',
        systemPrompt: 'Bạn là chuyên viên dịch thuật chuyên nghiệp. Dịch chính xác, giữ nguyên định dạng, văn phong tự nhiên.',
        sourceLang: 'vi',
        targetLang: 'en',
        isDemo: true,
        createdAt: new Date(),
        synonymGroups: DEMO_TERMS,
        importedTerminology: DEMO_TERMS,
    };
}

export function createDemoFile(): TranslationFile {
    return {
        id: DEMO_FILE_ID,
        projectId: DEMO_PROJECT_ID,
        fileName: 'demo-bao-cao-thuong-nien.txt',
        sourceText: DEMO_SOURCE_TEXT,
        translationStatus: 'pending',
        auditStatus: 'pending',
        currentStep: 1,
        originalFormat: 'txt',
        createdAt: new Date(),
        // Pre-fill credit estimate so demo shows token count immediately
        estimatedCredits: { translate: 420, qc: 126 },
    };
}
